/* sb-dc-logoimgpanel.js - when the Image panel is opened to replace a LOGO,
   show only the upload box. 2026-09-12.

   Reported: pressing "Replace logo" opens the editor's Image panel, and the
   panel's own "Replace this image" and "Remove background" buttons sit at the
   top of it. At that moment there is no image to replace or clean up - the
   customer is there to drop a file - so the two buttons are noise, and
   "Replace this image" right after "Replace logo" reads like the same button
   twice.

   WHAT THIS DOES: while a logo swap is waiting for a file, those two buttons
   are hidden. Everything else in the panel - the drop zone, the file picker -
   is untouched, and both buttons come back the moment the swap finishes or is
   abandoned.

   It watches for a click on our own bar (#sbdc-logotools-bar) rather than
   reading anything out of sb-dc-logoswap.js, so the two files stay
   independent: if the swap is ever removed, this simply never triggers.

   Ends when: an image lands on the board, the panel closes, or TIMEOUT.

   Diagnostics: window.__dcLogoImgPanel() */
(function () {
  'use strict';

  var TICK = 250, TIMEOUT = 180000;
  var HIDE = [/^replace this image$/i, /^remove background$/i];

  var info = { active: false, hidden: 0, restored: 0, why: '' };
  window.__dcLogoImgPanel = function () { return info; };

  var until = 0, touched = [], imagesAtStart = -1;

  function imageCount() {
    var a = window.__dcApi;
    if (!a || !a.front || !Array.isArray(a.front.layers)) return -1;
    var n = 0;
    a.front.layers.forEach(function (l) { if (l.type === 'image') n++; });
    return n;
  }

  document.addEventListener('click', function (e) {
    var bar = e.target && e.target.closest && e.target.closest('#sbdc-logotools-bar');
    if (!bar) return;
    until = Date.now() + TIMEOUT;
    imagesAtStart = imageCount();
    info.active = true;
  }, true);

  function hideButtons() {
    var panel = document.querySelector('.flyout');
    if (!panel) return;
    var btns = panel.querySelectorAll('button');
    for (var i = 0; i < btns.length; i++) {
      var t = (btns[i].textContent || '').replace(/\s+/g, ' ').trim();
      var match = false;
      for (var j = 0; j < HIDE.length; j++) if (HIDE[j].test(t)) match = true;
      if (!match) continue;
      if (btns[i].style.display === 'none') continue;
      btns[i].dataset.sbdcLogoHidden = '1';
      btns[i].style.display = 'none';
      touched.push(btns[i]);
      info.hidden++;
    }
  }

  function restore() {
    touched.forEach(function (b) {
      if (b && b.dataset && b.dataset.sbdcLogoHidden) {
        b.style.removeProperty('display');
        delete b.dataset.sbdcLogoHidden;
        info.restored++;
      }
    });
    touched = [];
    info.active = false;
    until = 0;
  }

  setInterval(function () {
    if (!until) return;

    if (Date.now() > until) { info.why = 'timeout'; return restore(); }

    /* the file landed - the swap is doing its work now */
    var n = imageCount();
    if (imagesAtStart >= 0 && n > imagesAtStart) { info.why = 'image added'; return restore(); }

    /* the customer closed the panel */
    if (!document.querySelector('.flyout')) { info.why = 'panel closed'; return restore(); }

    hideButtons();
  }, TICK);
})();
